export default __webpack_public_path__ + "static/media/program_intro_14.332d33d0.png";